'use client';

import { useCallback, useEffect, useRef } from 'react';
import type { ElasticArticle } from '@//app/api/articles/[slug]';

// import { useTrackArticleView } from '@//data/tracking/useTrackArticleView';

interface ArticleTrackerProps {
  article: ElasticArticle;
  threshold?: number;
  trackOnce?: boolean;
}

export const ArticleTracker = ({
  article,
  threshold = 0.5,
  trackOnce = true,
}: ArticleTrackerProps) => {
  //const { trackArticleView } = useTrackArticleView();
  const hasTracked = useRef(false);
  const trackerRef = useRef<HTMLDivElement>(null);

  const handleIntersection = useCallback(
    (entries: IntersectionObserverEntry[]) => {
      const [entry] = entries;

      if (entry.isIntersecting) {
        if (trackOnce && hasTracked.current) {
          return;
        }

        /*
        trackArticleView({
          id: article.id,
        });
        */
        hasTracked.current = true;
      }
    },
    [/*trackArticleView, */ article, trackOnce],
  );

  useEffect(() => {
    const trackerElement = trackerRef.current;
    if (!trackerElement) return;

    const nextSibling = trackerElement.nextElementSibling;
    if (!nextSibling) {
      console.warn('ArticleTracker: No next sibling element found to observe');
      return;
    }

    const observer = new IntersectionObserver(handleIntersection, {
      threshold,
      rootMargin: '0px',
    });

    observer.observe(nextSibling);

    return () => {
      observer.disconnect();
    };
  }, [handleIntersection, threshold]);

  return <div ref={trackerRef} style={{ display: 'none' }} />;
};
